import React from "react";
import { GitBranch } from "lucide-react";
import { FlowchartViewer } from "./FlowchartViewer";

const PAGES = [
  ["b-diary", "Daily Site Diary"],
  ["b-planning", "Planning"],
  ["b-records", "Records & Reports"],
  ["b-expenses", "Expenses"],
  ["b-photos", "Site Photos"],
  ["b-clients", "Clients"],
  ["b-wip", "Work In Progress"],
  ["b-attendance", "OH&S · Attendance"],
  ["b-inductions", "OH&S · Inductions"],
  ["b-safety-walks", "OH&S · Safety Walks"],
  ["b-toolbox", "OH&S · Toolbox Talks"],
  ["b-help", "Help & Support"],
  ["0-overview", "Defects & Walkthrough"],
];

export const BranchFlowcharts = () => (
  <FlowchartViewer id="branch-flowcharts" icon={GitBranch} title="Site Manager Flowcharts — every mindmap branch"
    blurb="A step-by-step flowchart for each branch. The PDF includes all of them plus the full Defects & Client Walkthrough stages."
    pdf="/docs/SitePro_Site_Manager_Flowcharts.pdf" pages={PAGES} />
);
